/* eslint-disable max-len */
module.exports.lang = {
    text: {
        coursedates: {
            start: {
                warning: `Warning: You have selected a course access date that is after the first day of classes.
            This may cause confusion as it will prevent students from seeing your course on their class list at the start of term.`,
            },
            end: {
                warning: `Warning: You have selected a course close date that is before the end of the exam period.
                This often causes access issues for students trying to access course content around exam time.`,
            },
            error: {
                beforeafterstart: 'Error: Open date must be set to a earlier date than close date.',
            },
            studentaccessendsheader: 'Student access ends',
            studentaccessbeginsheader: 'Student access begins',
            selecteddatelabel: 'Selected date',

        },
        assignrolessearch: {
            label: {
                requiresstudents: 'This non-credit course requires student access',
                enrolmanually: 'I will enrol them manually once the course has been created',
                enrolcohorts: 'I want to enrol cohorts of students from credit sections in eClass',
                other: 'Other (Please provide details below)',
            },
        },
        default: 'Default | Defaults',
        add: 'Add',
        airportnoflywarning: 'Warning: Placing a request in the No Fly List will delete both the eClass course and the request. Would you like to proceed?',
        canvasairportnoflywarning: 'Warning: Placing a request in the No Fly List will delete both the canvas course and the request. Would you like to proceed?',
        airportpatdownfailedwarning: 'Warning: Rejecting a patdown will delete the request. Would you like to proceed?',
        dialogcancel: 'Cancel',
        dialogproceed: 'Proceed',
        resettodefault: 'Reset to Default | Reset to Defaults',
        contentsource: 'Content Source',
        addcohortindicator: 'Add another section using the search above',
        blankcourse: 'Blank Course',
        enrolnamesblurb: 'Please enter the name or CCID of each individual who will be enrolled in the course in the following roles. Please note that more than one individual can be enrolled per role.',
        opendate: 'Open Date',
        closedate: 'Close Date',
        role: 'Role | Roles',
        required: 'Required',
        typetosearch: 'Type to search',
        nousersfoundsearch: 'No users found, please modify your search.',
        usersearchplaceholder: 'Search name or ccid',
        studentsourceplaceholder: 'Enter student source here',
        coursenamelabel: 'Course name',
        beartrackssectionslabel: 'Section(s) in this course',
        phonenumberlabel: 'Phone number',
        examplephonelabel: 'Example :',
        departmentlabel: 'Unit or department this course is associated with',
        coursecontentlabel: 'Course content',
        coursenamewarning: `Your course name appears to contain reference to a credit course ({0}). 
        eClass external should only be used to deliver courses accessible to users without 
        CCIDs. If this is the case for this course request, ignore this warning.`,
        courseshortnameexists: 'The course name already exists on eClass. Please change the course name to something unique.',
        coursecontent: {
            blanklabel: 'Blank',
            template: 'Default Template',
            showsectionslabel: 'Section(s) in this course:',
            previouscourseslabel: 'Select from your previous eClass courses',
            previouscanvascourseslabel: 'Select from any Canvas courses where you are enrolled as Teacher (An instructor or your department may need to add you to the course in a Teacher role before you can access it from this list.)',
            allcourseslabel: 'Search all eClass courses',
            allexternalcourseslabel: 'Search all eClass External courses',
            search: {
                previouscourseplaceholder: 'Select your previous course',
                allcourseplaceholder: 'Start typing to search by eclass course title',
                allexternalcourseplaceholder: 'Start typing to search by eclass external course title',
            },
            contentownership: 'I own this content or have the permission to copy this content',
            copyright: `By checking the box above, you are confirming that you are the copyright/intellectual property owner
            of the content in the course or that you have obtained the necessary permissions to use the content
            following the University's
            <a target='_blank'
                href="https://www.ualberta.ca/en/alfresco/uappol/academic/use-of-copyright-materials/policy/use-of-copyright-materials-policy.pdf"
            >Use of Copyright Content Guidelines</a>`,
            copyannouncements: 'Copy announcements from the selected course (announcements are excluded by default)',
            announcements: 'Announcements',
            announcementsincluded: 'Included',
            announcementsexcluded: 'Excluded',
            contentcopyoptionsheader: 'Content copy options',
            contentcopyoptionslabel: 'Exclude Quizzes, Question bank and Gradebook columns',
        },
        roles: {
            instructor: 'Instructor | Instructors',
            noneditingta: 'Non Editing TA | Non Editing TAs',
            ta: 'TA | TAs',
            designer: 'Designer | Designers',
            student: 'Student | Students',
            observer: 'Observer | Observers',
        },
    },
};
